export function setItem(key, value) {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(key, JSON.stringify(value));
  }
}

export function getItem(key) {
  if (typeof window !== 'undefined') {
    return JSON.parse(window.localStorage.getItem(key)) || null;
  }
  return null;
}

export function clear() {
  if (typeof window !== 'undefined') {
    window.localStorage.clear();
  }
}
